import { MutableRefObject } from 'react'

export const initialSurveyPrompt: MutableRefObject<string> = {
  current: '',
}
